import React, { Fragment } from "react";

export default function Tabs({ encabezado, children, className='' }) {
    return (
      <div className={`tabs ${className}`}>
        {encabezado} 
        {children}
      </div>
    );
}